export const messages = {
    "shared-link.footer.link.install": "免费试用 {brandName}",
    "shared-link.footer.link.mobile": "适用于移动设备的 {brandName}",
    "shared-link.footer.link.android": "Android",
    "shared-link.footer.link.ios": "iOS",
    "shared-link.password-dialog-box.title": "受保护的数据",
    "shared-link.password-dialog-box.message": "请指定共享数据的访问密码",
    "shared-link.password-dialog-box.hint.password": "密码",
    "shared-link.password-dialog-box.message.invalid-password": "密码不正确",
    "shared-link.form.button.open": "打开",
    "shared-link.page-not-found.title": "未找到页面",
    "shared-link.page-not-found.message.main": "找不到您要查找的页面。",
    "shared-link.page-not-found.message.description": "链接可能已过期，或者键入的地址不正确。",
    "shared-link.page-not-found.message.error": "错误代码：404",
    "shared-link.restore-file.label.size": "大小",
    "shared-link.restore-file.button.restore": "下载",
    "shared-link.links-table.column.name": "名称",
    "shared-link.links-table.column.size": "大小",
    "shared-link.links-table.action.restore": "下载",
    "shared-link.links-table.action.restore-all": "全部下载",
    "shared-link.side-bar.selected.title:plural": "{count} 个项目已选定 | {count} 个项目已选定",
    "shared-link.links-table.label.size": "大小",
    "shared-link.links-table.message.empty-folder": "此文件夹为空"
};
